// Components
import { FormControl } from '@mui/material';
import styled from 'styled-components';

const CustomFormControl = styled(({ color, isDarkMode, darkTheme, ...other }) => (
    <FormControl {...other} />
))(({ color, isDarkMode, darkTheme }) => ({
    '& .MuiOutlinedInput-root': { 
        borderRadius: 8,
        transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
        '&:hover fieldset': {
            borderColor: color,
            borderWidth: '1px',
        },
        '&.Mui-focused fieldset': {
            borderColor: color,
            borderWidth: '2px',
            boxShadow: isDarkMode 
                ? `0 0 0 0px ${color ? `${color}20` : 'rgba(255, 152, 0, 0.15)'}` 
                : color 
                    ? `0 0 0 0px ${color}20` 
                    : '0 0 0 0px rgba(25, 118, 210, 0.15)',
        },
    },
    '& .MuiInputLabel-root': {
        fontWeight: 400,
        '&.Mui-focused': {
            fontWeight: 400,
        },
    },
}));

export default CustomFormControl;